import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\ImpersonationController::stop
* @see Http/Controllers/Auth/ImpersonationController.php:20
* @route '/impersonation/stop'
*/
export const stop = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stop.url(options),
    method: 'post',
})

stop.definition = {
    methods: ["post"],
    url: '/impersonation/stop',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\ImpersonationController::stop
* @see Http/Controllers/Auth/ImpersonationController.php:20
* @route '/impersonation/stop'
*/
stop.url = (options?: RouteQueryOptions) => {
    return stop.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\ImpersonationController::stop
* @see Http/Controllers/Auth/ImpersonationController.php:20
* @route '/impersonation/stop'
*/
stop.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: stop.url(options),
    method: 'post',
})

const impersonation = {
    stop: Object.assign(stop, stop),
}

export default impersonation